/**
 * @module AlgoliaRobocuts
 * @description Initializes and manages Algolia product search grid for ROBOCUTs.
 */

import { createProductSearchGrid } from './BaseProductSearchGrid.js';
import { createProductConfig } from '@js/algolia/createProductConfig.js';
import { robocutsConfig } from '@js/config/algolia.js';

function getSpecs(result, translations = {}) {
  const specs = [];
  const maxWorkpieceWeightLabel =
    translations.maxWorkpieceWeight || 'Max Workpiece Weight';

  if (result.maxWorkpieceDimensionsDisplay) {
    specs.push({
      label: 'Max Workpiece Dimensions',
      value: result.maxWorkpieceDimensionsDisplay,
    });
  }

  if (result.maxWorkpieceWeightDisplay) {
    specs.push({
      label: maxWorkpieceWeightLabel,
      value: result.maxWorkpieceWeightDisplay,
    });
  }

  if (result.xyAxisTableTravelDisplay) {
    specs.push({
      label: 'XY Axis Table Travel',
      value: result.xyAxisTableTravelDisplay,
    });
  }

  return specs;
}

function hasSpecs(result) {
  return !!(
    result.maxWorkpieceDimensionsDisplay ||
    result.maxWorkpieceWeightDisplay ||
    result.xyAxisTableTravelDisplay
  );
}

function formatCardData(result, translations) {
  return {
    heading: result.title || '',
    url: result.absoluteUri || result.url || '#',
    image: result.productImage || null,
    category:
      result.productSeries && result.productSeries.length
        ? result.productSeries[0]
        : null,
    description: result.description || result.tagline || null,
    attributes: getSpecs(result, translations).map((spec, i) => ({
      icon:
        ['workpiece-dimensions', 'workpiece-weight', 'xy-table-travel'][i] ??
        null,
      label: spec.label,
      value: spec.value,
    })),
    legacy: result.legacy || false,
  };
}

export default createProductSearchGrid({
  appId: robocutsConfig.app_id,
  apiKey: robocutsConfig.api_key,
  indexName: robocutsConfig.index,
  configureWidget: createProductConfig('[data-search-robocuts]'),
  formatCardData,
  getSpecs,
  hasSpecs,
  scrollToSelector: '[data-search-robocuts]',
});
